import { get } from '../utils/http';

export const getRedirectToken = () =>
  get('propertyowners/redirectioncode')
    .then((response) => [null, response.data.response])
    .catch((error) => [error, null]);
